import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Http from './service/http'
import Http1 from './service/http1'
import './plugins/element.js'
// 导入字体图标
import './assets/fonts/iconfont.css'
import './assets/font/font.css'   //一般都是这个路径
// 导入全局样式表
import './assets/css/global.css'
import axios from 'axios'
// 导入nprogress 包对应的js和css
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import md5 from 'js-md5'
import 'swiper/dist/css/swiper.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'



// md5加密
Vue.prototype.$md5 = md5
Vue.prototype.$http = axios
Vue.prototype.$Http1=Http1
Vue.prototype.$Http=Http

Vue.use(axios)
Vue.use(VueAwesomeSwiper)
// 配置请求的跟路径
axios.defaults.baseURL = 'https://service.zhihuiyijiao.com/'
axios.defaults.wsuri = 'wss://service.zhihuiyijiao.com/ws'
// 在request拦截器中 展示进度条NProgress.start()

axios.interceptors.request.use(config => {
  NProgress.start()
  config.headers.Authorization = 'Bearer' + window.sessionStorage.getItem('token')
  // 在最后必须 return config
  return config
})
// 在response拦截器中,隐藏进度条NProgress.done()
axios.interceptors.response.use(config => {
  NProgress.done()
  return config
})
Vue.config.productionTip = false

new Vue({
  router,
  axios,
  render: h => h(App)
}).$mount('#app')
